import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyVideoBackgroundHotfixLayout = loadable(
  () => import(/* webpackChunkName: "content/guest/header/videoBackgroundHotfix" */ './VideoBackgroundHotfix'),
  'VideoBackgroundHotfixLayout',
);
